import React, { useState } from "react";
import { TextField } from "@material-ui/core";
import Clipboard from "react-clipboard.js";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import AssignmentIcon from "@material-ui/icons/Assignment";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert, { AlertProps } from "@material-ui/lab/Alert";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      alignItems: "center",
    },
    input: {
      flex: 1,
    },
    iconButton: {
      padding: 10,
      height: "56px",
    },
  })
);

function Alert(props: AlertProps) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const TextClipboard = (props: Props) => {
  const { value } = props;
  const [prevSrc, setPrevSrc] = useState(value);
  const [srcLength, setSrcLength] = useState(0);
  const [snackOpen, setSnackOpen] = useState(false);

  const classes = useStyles();

  React.useEffect(() => {
    setPrevSrc(value);
    if (value) {
      setSrcLength(value.length);
    }
  }, [value]);

  const handleOpen = () => {
    setSnackOpen(true);
    setTimeout(() => {
      setSnackOpen(false);
    }, 1500);
  };

  return (
    <div className={classes.root} style={{ width: `${srcLength / 1.7}rem` }}>
      <TextField
        value={prevSrc}
        InputProps={{
          readOnly: true,
        }}
        className={classes.input}
        variant="filled"
      />
      <Clipboard
        data-clipboard-text={prevSrc}
        className={classes.iconButton}
        onClick={handleOpen}
      >
        <AssignmentIcon />
      </Clipboard>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={snackOpen}
      >
        <Alert severity="success">copyしました。</Alert>
      </Snackbar>
    </div>
  );
};
export default TextClipboard;
